import 'sass/web.scss'

import 'js/helpers/compatibility';
import track from 'js/helpers/analytics';

import navToggler from 'js/web/mobile-nav';
import video from 'js/web/video';
import scrollControl from 'js/web/scroll-control';


track.init(document.body.dataset.analyticsId)
track.pageview()

// register global error handler
window.onerror = function (message, file, line, col, error) {
    track.exception('Uncaptured: ' + message + ' on ' + file + ':' + line + '-' + col, error)
}

function ready(fn) {
    if (document.readyState != 'loading'){
        fn();
    } else {
        document.addEventListener('DOMContentLoaded', fn);
    }
}

ready(function() {

    document.documentElement.className += (('ontouchstart' in document.documentElement) ? ' touch' : ' no-touch')

    navToggler('.page-nav', '.page-nav__item--opener', '.page-nav__backdrop')

    video('.modal', '#video-thumb-student', '.modal__content', '.modal__backdrop', '.modal__button-close')
    video('.modal', '#video-thumb-teacher', '.modal__content', '.modal__backdrop', '.modal__button-close')


    // make sure home header is size of actual visible viewport
    let header = document.querySelectorAll('.page-header--home')[0]
    if ( header != null && window.innerWidth > 576 && window.innerHeight > 600 && window.pageYOffset >= 0 && header.offsetHeight > (window.innerHeight + window.pageYOffset) ) {
        header.style.height = (window.innerHeight + window.pageYOffset) + 'px'
        header.style.minHeight = header.style.height
    }

    // wait some time to make sure element positions are calculated
    setTimeout( () => {
        const scrollables = document.querySelectorAll('.scroller__element')
        for (const elem of scrollables) {
            scrollControl(elem, (update, el) => {
                el.style.transform = 'translateX(' + (update.progress * 50 - 28) +'%)'
            })
        }

        const nav = document.getElementsByTagName('nav')[0];
        const navStickyOffset = 20
        scrollControl(nav, ({ scroll }, el) => {
            if ( scroll > navStickyOffset ) {
                el.classList.add('is-stickied')
            } else {
                el.classList.remove('is-stickied')
            }
        }, true) // skips el recalc

        const secondaryNav = document.querySelectorAll('.secondary-nav')[0]
        const secondaryNavStickyOffset = nav.offsetHeight
        scrollControl(secondaryNav, ({ fromTop }, el) => {
            if ( fromTop < secondaryNavStickyOffset ) {
                el.classList.add('is-stickied')
            } else {
                el.classList.remove('is-stickied')
            }
        })

    }, 50);


    /*
     * ALERTER
     */
    const alerters = {
        // 'inquiry-register': { message: 'Heb je een uitnodigingscode ontvangen voor jouw klas?', action: () => window.location.replace('/registreren') },
    }

    const alertAction = function(data) {
        return () => {
            if ( window.confirm(data.message) ) {
                data.action()
            }
        }
    }

    for (const a in alerters) {
        const el = document.getElementById(a)
        if ( el != null ) {
            el.addEventListener('click', alertAction( alerters[a] ) )
        }
    }

    /*
     * TOGGLER
     */
    const togglers = {
        'inquiry-school-toggle': 'inquiry-school',
    }

    const toggleElement = function(el) {
        return e => {
            e.preventDefault()
            if (el != null) {
                toggleClass(el, 'toggled')
                const autofocusEl = el.querySelector('input.autofocus')
                if (autofocusEl) {
                    autofocusEl.focus()
                }
            }
        }
    }

    const toggleClass = function(element, className) {
        const classes = element.className.split(' ')
        const i = classes.indexOf(className)

        if (i >= 0) {
            classes.splice(i, 1)
        } else {
            classes.push(className)
        }

        element.className = classes.join(' ');
    }

    for (const t in togglers) {
        const el = document.getElementById(t)
        if ( el != null ) {
            el.addEventListener('click', toggleElement( document.getElementById(togglers[t]) ))
        }
    }

})



// WEBPACK FOOTER //
// ./resources/assets/js/web/web.js